/// <reference types="node" />
import { animate, style, transition, trigger } from '@angular/animations';
import { Component, effect, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-mini-alert',
  templateUrl: './mini-alert.component.html',
  styleUrls: ['./mini-alert.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-1em) translateX(-50%)' }),
        animate('300ms ease-in', style({ opacity: 1, transform: 'translateY(0) translateX(-50%)' })),
      ]),
      transition(':leave', [
        style({ opacity: 1, transform: 'translateY(0) translateX(-50%)' }),
        animate('300ms ease-out', style({ opacity: 0, transform: 'translateY(-1em) translateX(-50%)' })),
      ]),
    ]),
  ],
  standalone: true,
  imports: [FaIconComponent],
})
export class MiniAlertComponent {
  circleMark = faCircleXmark;

  timeout!: NodeJS.Timeout;

  message: InputSignal<string> = input('');
  toggle: InputSignal<boolean> = input(false);

  onToggleChange: OutputEmitterRef<boolean> = output<boolean>();

  _toggle: boolean = false;

  constructor() {
    effect(() => {
      if (this.toggle()) {
        this.openAlert();
      } else {
        this.forceCloseAlert();
      }
    });
  }

  openAlert(): void {
    this._toggle = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this._toggle = false;
      this.onToggleChange.emit(false);
    }, 5000);
  }

  forceCloseAlert(): void {
    clearTimeout(this.timeout);
    this._toggle = false;
    this.onToggleChange.emit(false);
  }
}
